import SkeletonCard from "@@/components/Loader/Skeleton/Card/skeletonCard";
import Box from "@@/elements/Box";
import { ReactNode } from "react";
import styles from "./styles.module.scss";

export const multiRender = (amount: number, element: ReactNode) => [...Array(amount)].map((_, i) => <Box className={styles.item} key={i}>{element}</Box>);


const CardsLoader = () => {
  return (
  <Box className={styles.cards_wrapper} mt={7} gap={[4, 4, 10]}>
    {multiRender(9, <SkeletonCard variant="newslisting" />)}
  </Box>
);
};

export default CardsLoader;
